var _webTrendsTrackerLoaded = false;

/**
 * An object to manage WebTrends Analytics as a TrackerManager plugin
 * @constructs WebTrendsTracker
 * @memberof Class
 * @author Alessandro Cipolletti
 */
function WebTrendsTracker(serverConfNode) {

	this.account = serverConfNode.id;
	this.domain = serverConfNode.domain;
	this.url = serverConfNode.url;

	this.loadTracker();

}

WebTrendsTracker.prototype.isLoaded = function () {
	return _webTrendsTrackerLoaded;
}

/**
 * Load the analytics tracker
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.loadTracker = function () {

	if (_webTrendsTrackerLoaded) {
		return;
	}

	window.webtrendsAsyncInit = WebTrendsTracker.prototype.init.bind({}, {
		account: this.account,
		domain: this.domain
	});

	var g = document.createElement("script");
	var s = document.getElementsByTagName("script")[0];
	g.type = "text/javascript";
	g.async = true;
	g.defer = true;
	g.onload = function () {
		_webTrendsTrackerLoaded = true;
	};
	g.src = this.url + "webtrends.min.js";
	s.parentNode.insertBefore(g, s);

};

/**
 * Init Webtrends dcs track object
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.init = function (config) {

	window.dcs = new Webtrends.dcs().init({
		dcsid: config.account,
		dcsdelay: 20,
		delayAll: true,
		domain: config.domain,
		enabled: true,
		preserve: false,
		timezone: -5,
		i18n: true,
		adimpressions: true,
		adsparam: "WT.ac",
		offsite: true,
		download: true,
		downloadtypes: "xls,doc,pdf,txt,csv,zip,docx,xlsx,rar,gzip",
		anchor: true,
		javascript: true,
		onsitedoms: 'uat-www.ds.ssga.com',
		plugins: {
			facebook: {
				src: "//s.webtrends.com/js/webtrends.fb.js"
			},
			yt: {
				src: "//s.webtrends.com/js/webtrends.yt.js"
			}
		}
	}).track();

};

/**
 * Track a page view
 * @param  {String} page  The page code name viewed
 * @param  {String} hash  The hash of the page viewed
 * @param  {String} title The page title
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.trackPage = function (page, url, title) {

	dcsMultiTrackIfExists(url, title, 0, 5);

	// dcsMultiTrack("DCS.dcsuri", url, "WT.ti", title, "WT.dl", 0);
	

};

/**
 * Track a page event
 * @param  {String}  category The event category
 * @param  {String}  action   The event name
 * @param  {String}  label    The action label
 * @param  {integer} value    A complementary figure
 * @author Alessandro Cipolletti
 */
WebTrendsTracker.prototype.trackEvent = function (category, action, label, value) {
	dcsMultiTrackIfExists(action, label, 20, 5);
};

// Needed because the first stat call is done too soon
function dcsMultiTrackIfExists( type, name, code, triesLeft ) {
	if (window.dcsMultiTrack !== undefined) {
		dcsMultiTrack("DCS.dcsuri", type, "WT.ti", name, "WT.dl", code);
		return;
	}
	if (triesLeft > 0) {
		setTimeout(function(){
			dcsMultiTrackIfExists(type, name, code, triesLeft - 1);
		}, 2000);
	}
}

module.exports = WebTrendsTracker;



//////////////////
// WEBPACK FOOTER
// ./src/utils/statistics/trackers/webTrendsTracker.js
// module id = 788
// module chunks = 0